function textDots(string, max = 20) {
    return string && string.length > max ? `${string.slice(0, max)}...` : string;
}
export { textDots };
